import { pickNextPandaVariant, pickPandaVariant, type PandaVariant } from '../../domain/panda';

const LAST_PANDA_VARIANT_KEY = 'mail-panda-last-variant';

function pickLaunchPandaVariant(): PandaVariant {
  if (typeof window === 'undefined') return pickPandaVariant();
  try {
    const variant = pickNextPandaVariant(window.localStorage.getItem(LAST_PANDA_VARIANT_KEY));
    window.localStorage.setItem(LAST_PANDA_VARIANT_KEY, variant);
    return variant;
  } catch {
    return pickPandaVariant();
  }
}

const launchPandaVariant = pickLaunchPandaVariant();

function PandaFace({ variant }: { variant: PandaVariant }) {
  const cheerful = variant === 'cheer';
  return (
    <>
      <ellipse className="panda-black" cx="35" cy="39" rx="9" ry="11" transform="rotate(18 35 39)" />
      <ellipse className="panda-black" cx="65" cy="39" rx="9" ry="11" transform="rotate(-18 65 39)" />
      {cheerful ? (
        <>
          <path className="panda-eye-expression" d="M30 40 Q35 34 40 40" />
          <path className="panda-eye-expression" d="M60 40 Q65 34 70 40" />
        </>
      ) : (
        <>
          <circle className="panda-eye-dot" cx="36" cy="38" r="1.8" />
          {variant === 'wink'
            ? <path className="panda-eye-expression panda-wink" d="M60 40 Q65 34 70 40" />
            : <circle className="panda-eye-dot" cx="64" cy="38" r="1.8" />}
        </>
      )}
      <circle className="panda-cheek" cx="25" cy="50" r="5.5" />
      <circle className="panda-cheek" cx="75" cy="50" r="5.5" />
      <ellipse className="panda-black" cx="50" cy="47" rx="4.5" ry="3.2" />
      <path className="panda-mouth" d={cheerful ? 'M44 51 Q50 59 56 51' : 'M42 51 Q46 57 50 52 Q54 57 58 51'} />
    </>
  );
}

function PandaBody({ variant }: { variant: PandaVariant }) {
  const isMail = variant === 'mail';
  const isCheer = variant === 'cheer';
  return (
    <g className="panda-body">
      <ellipse className="panda-black" cx="50" cy="77" rx="25" ry="20" />
      <ellipse className="panda-white" cx="50" cy="78" rx="11" ry="15" />
      <ellipse className="panda-black panda-foot" cx="31" cy="90" rx="13" ry="7" transform="rotate(-8 31 90)" />
      <ellipse className="panda-black panda-foot" cx="69" cy="90" rx="13" ry="7" transform="rotate(8 69 90)" />
      {isCheer ? (
        <>
          <path className="panda-black panda-arm panda-arm-left" d="M32 75 Q20 72 17 58 Q16 53 21 52 Q26 52 28 59 L36 69 Z" />
          <path className="panda-black panda-arm panda-arm-right" d="M68 75 Q80 72 83 58 Q84 53 79 52 Q74 52 72 59 L64 69 Z" />
        </>
      ) : (
        <>
          <ellipse className="panda-black panda-arm" cx="31" cy="73" rx="8" ry="13" transform="rotate(25 31 73)" />
          <ellipse className="panda-black panda-arm" cx="69" cy="73" rx="8" ry="13" transform="rotate(-25 69 73)" />
        </>
      )}
      {isMail && (
        <g className="panda-envelope">
          <rect x="35" y="66" width="30" height="20" rx="2.5" />
          <path d="M36 68 L50 78 L64 68" />
          <circle cx="50" cy="78" r="2.8" />
          <circle className="panda-black" cx="34" cy="76" r="4" />
          <circle className="panda-black" cx="66" cy="76" r="4" />
        </g>
      )}
    </g>
  );
}

export function PandaMark({ size = 40, variant = launchPandaVariant, animated = false }: { size?: number; variant?: PandaVariant; animated?: boolean }) {
  const compact = size <= 40;
  return (
    <span className={`panda-mark panda-${size} variant-${variant}${animated ? ' is-animated' : ''}`} aria-hidden="true">
      <svg viewBox={compact ? '8 5 84 61' : '0 0 100 100'} focusable="false">
        {!compact && <PandaBody variant={variant} />}
        <circle className="panda-black panda-ear panda-ear-left" cx="27" cy="19" r="13" />
        <circle className="panda-black panda-ear panda-ear-right" cx="73" cy="19" r="13" />
        <path className="panda-black" d="M10 35 C10 16 27 7 50 7 C73 7 90 16 90 35 L90 45 C90 61 73 68 50 68 C27 68 10 61 10 45 Z" />
        <path className="panda-white" d="M15 35 C15 21 30 14 50 14 C70 14 85 21 85 35 L85 44 C85 57 70 63 50 63 C30 63 15 57 15 44 Z" />
        <PandaFace variant={variant} />
      </svg>
    </span>
  );
}
